import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import styled from 'styled-components';
import { throttle } from 'lodash';

const NavStyled = styled.nav`
    background-color: ${props => props.theme.nav.backgroundColor};
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;

const Link = styled(NavLink)`
    background-color: ${props => props.theme.nav.backgroundColor};
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    font-size: 14px;
    color: ${props => props.theme.nav.color};
    text-transform: uppercase;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    width: 50%;

    &.active {
        border-color: ${props => props.theme.nav.borderColor};
        color: ${props => props.theme.nav.activeColor};
    }
`;

const Nav = () => {
    const [winWidth, setWinWidth] = useState(window.innerWidth);
    const resizeHandler = throttle(() => {
        setWinWidth(window.innerWidth);
    }, 200, { 'leading': true });


    window.addEventListener('resize', resizeHandler);

    return (
        <NavStyled>
            <Link to="/" exact>{winWidth < 500 ? 'Политика' : 'Политика за поверителност'}</Link>
            <Link to="/settings">{winWidth < 500 ? 'Настройки' : 'Настройки за поверителност'}</Link>
        </NavStyled>
    )
}

export default Nav;